export default __webpack_public_path__ + "static/media/logo.c05b638f.png";